class BlockOnglets {
  constructor() {
    this._init();
  }

  _init() {
    const questions = document.querySelectorAll('.onglets__item');

    questions.forEach(function (question) {
      question.addEventListener(
        'click',
        function () {
          question.classList.toggle(
            'active'
          );
        },
        false
      );
    });
  }
}

export const blockOnglets = new BlockOnglets();
